<template>
  <v-card class="bordered-card" :id="id">
    <video
        v-if="mode === 'video'"
        style="height: 235px; object-fit: cover; border-radius: 15px"
        width="100%"
        :ref="reff"
        :playsinline="playsinline"
        :autoplay="autoplay"
        :controls="controls"
        :muted="muted"
        :class="mirror ? 'mirror' : ''"
    />
    <audio
        style="border-radius: 15px!important; width: 100%"
        v-else-if="mode === 'audio'"
        :ref="reff"
        :autoplay="fileSharer.id != currentUser.id"
        :controls="controls"
    />
    <v-icon v-if="mode === 'audio' && !controls" size="100px">mdi-volume-high</v-icon>
    <div class="under-video-layer">
      <v-btn v-if="fileSharer && fileSharer.id == currentUser.id" type="button" fab x-small :color="colors.success"
             class="white--text ml-1" @click="$emit('cancelFileSharing')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <div :class="[selfChip ? 'current-user-chip' : 'user-chip']">
        <v-btn type="button" fab x-small text @click="$emit('toggleFullScreen', id)">
          <v-icon>mdi-fullscreen</v-icon>
        </v-btn>
        {{ chipText }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MeetingSimpleCardMobile",
  props: [
    'id',
    'muted',
    'reff',
    'colors',
    'user',
    'selfChip',
    'chipText',
    'currentUser',
    'fileSharer',
    'playsinline',
    'autoplay',
    'controls',
    'mode',
    'mirror'
  ],
}
</script>

<style scoped>
.bordered-card {
  border: 1px solid black;
  border-radius: 15px !important;
  padding: 0 0 40px;
  height: 275px;
}

.user-chip {
  width: 100%;
  padding: 0 10px;
  justify-content: space-between;
  background-color: #e0e0e0;
  border-radius: 15px;
  font-size: 10px;
  text-align: center;
  align-items: center;
  display: flex;
}

.current-user-chip {
  width: 100%;
  justify-content: space-between;
  padding: 0 10px;
  color: white;
  background-color: #f44336;
  border-radius: 15px;
  font-size: 10px;
  text-align: center;
  align-items: center;
  display: flex;
}

.under-video-layer {
  height: 35px;
  margin-top: 3px;
  bottom: 0;
  position: absolute;
  padding: 0 3px;
  width: 100%;
  right: 0;
  left: 0;
  text-align: right !important;
}

.mirror {
  transform: rotateY(180deg);
  -webkit-transform:rotateY(180deg); /* Safari and Chrome */
  -moz-transform:rotateY(180deg); /* Firefox */
}
</style>